// extracted by mini-css-extract-plugin
module.exports = {"header":"ComplianceHistoryModal_header__XE-iv","periodSelect":"ComplianceHistoryModal_periodSelect__2R_8r","selectTrigger":"ComplianceHistoryModal_selectTrigger__1au0G"};